import { createSlice } from "@reduxjs/toolkit";

interface AddressDetailsState {}

const initialState: AddressDetailsState = {};

const addressDetailsSlice = createSlice({
  name: "addressDetails",
  initialState,
  reducers: {
    destroy() {
      return initialState;
    }
  }
});


export default addressDetailsSlice.reducer;
export const {
  destroy
} = addressDetailsSlice.actions;
export const addressDetailsActions = addressDetailsSlice.actions;
